import { Flex } from '@chakra-ui/react';
import FunwooSpinner from '@/components/FunwooSpinner';

export default function Spinner({ loading }) {
  if (!loading) {
    return null;
  }
  return (
    <Flex pos='absolute' left={0} top={0} w='100vw' h='100vh' justify='center' align='center'>
      <Flex pos='absolute' w='100vw' h='100vh' opacity={0.2} bg='#000' />
      <FunwooSpinner />
    </Flex>
  );
}
